export const BOOSTPAD_URL = 'https://boostpad.com'

export const BOOSTPAD_DESCRIPTION = 'Boostpad is a senior digital product studio based in Buenos Aires and California, building complete products, apps, AI services, games and immersive experiences for clients worldwide.'

export const BOOSTPAD_FOUNDING_DATE = '2008'

export const BOOSTPAD_SAME_AS: string[] = []

export const BOOSTPAD_CLIENTS = [
  'Nickelodeon',
  'Ford',
  'HP',
  'Breitling',
  'Budweiser',
  'Honda',
  'Mattel',
  'Neon',
] as const

export const BOOSTPAD_CLIENTS_STATEMENT = 'Boostpad has developed products for Nickelodeon, Ford, HP, Breitling, Budweiser, Honda, Mattel and Neon.'

export const BOOSTPAD_APPLE_HISTORY = 'Boostpad has been developing for Apple platforms since the first iPhone SDK in 2008.'

export function canonicalUrl(path: string) {
  if (path === '/') return `${BOOSTPAD_URL}/`
  return `${BOOSTPAD_URL}${path.replace(/\/$/, '')}/`
}
